// extracted by mini-css-extract-plugin
export var dataCell = "_i2-2";
export var dataRow = "_i2-0";
export var headerRow = "_i2-1";